module.exports = __webpack_public_path__ + "static/media/cinta_tex.f767f05c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/cinta/cinta_tex.png
// module id = 345
// module chunks = 0